export const ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const INFO_MESSAGE = 'INFO_MESSAGE'
export const LICENSE_MESSAGE = 'LICENSE_MESSAGE'
